// extracted by mini-css-extract-plugin
export default {"action_message":"Messages_action_message__9WTfS","validation_error_msg":"Messages_validation_error_msg__iOAsb"};